import { LoyaltySvgIcon, type LoyaltyIconProps } from './LoyaltySvgIcon';

export const CigaretteIcon = (props: LoyaltyIconProps): JSX.Element => (
    <LoyaltySvgIcon {...props}>
        <path d="M2.5 15.5h13.5v3H2.5z" />
        <path d="M17.2 15.5h4.3v3h-4.3z" />
        <path d="M16.2 3.2c1.9 0 3.4 1.5 3.4 3.4 0 .9-.35 1.75-.95 2.35 1.6.65 2.65 2.2 2.65 4V14h-1.5v-1.05c0-1.55-1.25-2.8-2.8-2.8h-.8V8.6h.55c1 0 1.85-.85 1.85-1.95 0-1.05-.85-1.9-1.9-1.9h-.5V3.2z" />
    </LoyaltySvgIcon>
);
